import { CLIENT_API } from "@/services/axios-client";
import { useQuery } from "@tanstack/react-query";

export const useGetMeditationRetreatLevels = () => {

    const { data, isLoading, error } = useQuery<Level[], Error>({
        queryKey: ["meditationRetreatLevels"],
        queryFn: () => CLIENT_API.getLevels(),
        staleTime: 1000 * 60 * 60 * 24, // 24 hours
    });

    return {
        data,
        isLoading,
        error
    }
}